import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { MatInputModule } from '@angular/material/input'
import {
  MatCell,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow,
  MatRow,
  MatTable,
  MatTableDataSource,
  MatTableModule,
} from '@angular/material/table'
import { MatIcon } from '@angular/material/icon'
import {
  MatPaginator,
  MatPaginatorModule,
} from '@angular/material/paginator'
import { ContactService } from '../../../core/services/contact/contact/contact.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { ResponseRequestModel } from '../../../core/models/response.model'
import { MatProgressBar } from '@angular/material/progress-bar'
import { ContactClientEditFormComponent } from './contact-client-form/contact-client-edit-form.component'
import { FormClientSearchComponent } from '../../../shared/components/form-client-search/form-search.component'
import { responseDefaultForm } from '../../../shared/utils/utils'
import { MatDivider } from '@angular/material/divider'

@Component({
  selector: 'contact-client-edit',
  imports: [
    MatInputModule,
    MatCell,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatIcon,
    MatPaginator,
    MatRow,
    MatTable,
    MatTableModule,
    MatIcon,
    MatPaginatorModule,
    MatTable,
    MatProgressBar,
    ContactClientEditFormComponent,
    FormClientSearchComponent,
    MatDivider,
  ],
  templateUrl: './contact-client-edit.component.html',
  styleUrl: './contact-client-edit.component.scss',
  providers: [ContactService],
  standalone: true,
})
export class ContactClientEditComponent implements OnInit, AfterViewInit {
  constructor(
    private contactService: ContactService,
    private snackbar: SnackbarCustomService,
  ) {}

  item: any = {}
  loading = true

  @Output() response = new EventEmitter<any>()
  @Input() idPerson = 0
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined
  @ViewChild(MatTable) table: MatTable<any> | undefined

  columns: any[] = [
    {
      keyColumn: 'contactType',
      key: 'tipoContatoDescricao',
      description: 'Tipo contato',
    },
    {
      keyColumn: 'description',
      key: 'descricao',
      description: 'Descrição',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    },
  ]

  page = 1
  rows = 10
  tableSource: MatTableDataSource<any> = new MatTableDataSource<any>()
  displayedColumns: string[] = ['contactType', 'description', 'action']

  inputSearchContact: any = { type: '', search: '' }
  listSearch: any = [
    {
      id: 'tipoContatoId',
      description: 'Tipo Contato',
      type: 'number',
      visible: false,
    },
    {
      id: 'descricao',
      description: 'Descrição',
      type: 'string',
      visible: true,
    },
  ]
  searchForm: any = { search: false, model: {} }

  ngOnInit(): void {
    this.getContactByPerson()
  }

  ngAfterViewInit() {
    this.refreshTable()
  }

  refreshTable() {
    if (this.paginator) {
      this.tableSource.paginator = this.paginator
    }
    // if (this.table) {
    //   this.table.renderRows()
    // }
  }

  pageChanged($event: any) {
    this.page = $event.pageIndex + 1
    // this.rows = $event.pageSize
    this.uploadList()
  }

  uploadList(type = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
    }
    if (this.searchForm.search) {
      this.searchContact()
    } else {
      this.getContactByPerson()
    }
  }

  getContactByPerson() {
    this.loading = true
    this.contactService
      .listPagedContactByPerson(this.idPerson, this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  searchContact() {
    this.loading = true
    this.contactService
      .searchPagedContact(this.page, this.rows, this.searchForm.model)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push({
          ...item,
        })
      }
    }
    this.tableSource = new MatTableDataSource<any>(list)
    this.refreshTable()
  }

  responseForm(response: any): void {
    if (response.refresh) {
      this.uploadList()
    }
    if (response.clear) {
      this.clearItem()
    }
  }

  updateItem(element: any) {
    this.item = { edit: true, data: element }
  }

  deleteItem(element: any) {
    this.clearItem()
    this.contactService.deleteContact(element.id).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
        this.snackbar.success(err.message)
        this.loading = false
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  clearItem() {
    this.item = {}
  }

  createModel(element: any) {
    const model: any = { pessoaId: this.idPerson }
    for (let i = 0; i < this.listSearch.length; i++) {
      const item = this.listSearch[i]
      model[item.id] =
        item.id == element.type
          ? element.search
          : responseDefaultForm(item.type)
    }
    return model
  }

  search(event: any) {
    if (event.search) {
      this.searchForm = {
        search: true,
        model: this.createModel(event.data),
      }
    }
    this.page = 1
    this.uploadList(!event.search ? 'new' : '')
  }
}
